import { ConfigData } from '@configs/config-data.type';
import { configs } from '@configs/config-list.import';

export const config: ConfigData = getConfig();

function getSubdomain(): string {
    const [subdomain, ...rest] = window.location.hostname?.split(".");
    if (!rest?.length) {
        return 'local';
    }
    return subdomain;
}

function getConfig() {
	const configKey = getSubdomain();
	return configs[configKey];
}
